import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';

const IncidentFormHistoryTableColumns = (): JSX.Element => (
  <SimpleTableRow header>
    <SimpleTableCell name="INCIDENT" className="w-md-grow">
      Incidents
    </SimpleTableCell>
    <SimpleTableCell name="DATE_TIME">Date/Time</SimpleTableCell>
  </SimpleTableRow>
);

export default IncidentFormHistoryTableColumns;
